import ReactDOM from 'react-dom';
import React, { useState } from 'react';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import TreatmentPatientButton from './TreatmentPatientButton';
import { Provider } from 'react-redux';
import { store } from '../../store/store';
import AclContextProvider from '../../Modules/Acl/Components/AclContextProvider';
import PatientTreatment from '../../Modules/Patient/Components/PatientTreatment';

loadDOMComponent({
	selector: 'react-treatment-patient-button',
	callback: ({ container, context, props }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const patientId = container.getAttribute('patientId');
		const loggedUserId = container.getAttribute('loggedUserId');
		const className = container.getAttribute('className');
		const text = container.getAttribute('text');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<TreatmentPatientButton
							text={text}
							patientId={patientId}
							workplaceId={workplaceId}
							loggedUserId={loggedUserId}
							className={className}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
